import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "actions" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item-text" }

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ChevronDown, Check, X } from "utruckin-icons";
import { IDropdown, IDropdownOptions } from "@/types/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonDropdown',
  props: {
    position: { default: "bottom" },
    label: { default: "" },
    items: { default: () => [] },
    modelValue: { default: "" },
    disabled: { type: Boolean, default: false },
    showBadge: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    maxWidth: {},
    dropdownFullWidth: { type: Boolean, default: false },
    isAppendItem: { type: Boolean },
    creatable: { type: Boolean },
    fullWidth: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(false);
const rootRef = ref<HTMLElement | null>(null);

const listStyle = ref({
  top: "0px",
  left: "0px",
  width: "200px",
  transformOrigin: "top",
});

const selectedItem = computed(() => {
  return props.items.find((i) => i.value === props.modelValue) ?? null;
});

const selectedLabel = computed(() => selectedItem.value?.name || "");
const selectedColor = computed(() => selectedItem.value?.color || null);

const hasSelection = computed(() => selectedLabel.value.length > 0);

function updateListPosition() {
  if (!rootRef.value) return;
  const rect = rootRef.value.getBoundingClientRect();
  listStyle.value = {
    width: `${rect.width}px`,
    left: `${rect.left + window.scrollX}px`,
    top:
      props.position === "top"
        ? `${rect.top + window.scrollY - 6}px`
        : `${rect.bottom + window.scrollY + 6}px`,
    transformOrigin: props.position === "top" ? "bottom" : "top",
  };
}

function toggle() {
  if (props.disabled) return;
  if (!isOpen.value) {
    updateListPosition();
  }
  isOpen.value = !isOpen.value;
}

function choose(item: IDropdown) {
  emit("update:modelValue", item.value);
  isOpen.value = false;
}

function onDocumentClick(e: MouseEvent) {
  const el = rootRef.value;
  if (!el) return;
  const target = e.target as Node | null;
  if (!target) return;
  if (!el.contains(target)) {
    isOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", onDocumentClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick);
});

const clearValue = () => {
  emit("update:modelValue", null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootRef",
    ref: rootRef,
    class: _normalizeClass(["c-co-dropdown", {
      active: isOpen.value,
      disabled: __props.disabled,
      'full-width': __props.fullWidth,
    }]),
    onClick: toggle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'is-placeholder': !hasSelection.value }])
    }, [
      (hasSelection.value && selectedColor.value)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "color-dot",
            style: _normalizeStyle({ backgroundColor: `var(${selectedColor.value})` })
          }, null, 4))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(selectedLabel.value || __props.label), 1)
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      (__props.clearable && __props.modelValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "clear",
            onClick: clearValue
          }, [
            _createVNode(_unref(X), { size: 20 })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["icon", { rotate: isOpen.value }])
      }, [
        _createVNode(_unref(ChevronDown), { size: 20 })
      ], 2)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "c-co-dropdown__list",
            style: _normalizeStyle({
          position: 'fixed',
          top: listStyle.value.top,
          left: listStyle.value.left,
          width: listStyle.value.width,
          transform: __props.position === 'top' ? 'translateY(-100%)' : 'none',
        })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value || index,
                class: "c-co-dropdown__item",
                onClick: _withModifiers(($event: any) => (choose(item)), ["stop"])
              }, [
                (item.color)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "color-dot",
                      style: _normalizeStyle({ backgroundColor: `var(${item.color})` })
                    }, null, 4))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1),
                (item.value === __props.modelValue)
                  ? (_openBlock(), _createBlock(_unref(Check), {
                      key: 1,
                      class: "check"
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_2))
            }), 128))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}
}

})